import React from 'react'
import { useParams } from 'react-router-dom'
import ProjectExpenseForm from './ProjectExpenseForm'

const ProjectExpenseEdit = () => {
  const { id } = useParams()

  return (
    <ProjectExpenseForm 
      mode="edit" 
      expenseId={id}
    />
  )
}

export default ProjectExpenseEdit

